import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { GoalAnalysisService } from '../../services/goal-analysis.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';

@Component({
  selector: 'gp-cash-flow',
  templateUrl: './cash-flow.component.html',
  styleUrls: ['./cash-flow.component.scss']
})
export class CashFlowComponent implements OnInit, OnDestroy {

  protected _storeDataSubscription: Subscription;

  dataSource;
  //displayedColumns: string[] = ['c1Age', 'c2Age',  'c1EmpIncome', 'c2EmpIncome', 'totTax', 'totExpense'];
  //displayedColumns: string[] = ['yr', 'totSavings', 'portInc', 'totIncome', 'portTaxes', 'totExpense', 'totTax',  'netCashFlow'];
  displayedColumns: string[] = ['yr', 'portBeginBal', 'totIncome', 'portInc', 'totExpense', 'totTax', 'portTaxes', 'totSavings', 'netCashFlow', 'portEndBal'];
  //displayedColumns: string[] = ['yr', 'c1Age', 'c1EmpIncome', 'c1PreTaxSaving', 'c1AfterTaxSaving', 'totSavings', 'portTaxes', 'portInc', 'totTax', 'totExpense',  'capitalGL', 'netCashFlow'];

  isDataAvailable = false;
  
  constructor(private dataService: DataService,
      private uiStateService: UIStateService,  
      private goalAnalysisService: GoalAnalysisService,
      private appMonitoringService: AppMonitoringService) {    
  }

  ngOnInit(): void {
    //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "CashFlowComponent-ngOnInit", true);
    this.dataService.getPlanAnalysis();        
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
  }

  private populateAppData(appData: fromModel.IAppData){
    this.dataSource = null;
    this.isDataAvailable = false;
    if(appData && (appData.action===fromModel.DATA_ACTION.UPDATESETTINGS)){        
      this.dataService.getGoalSummary();
      this.dataService.getPlanAnalysis();      
    }
    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){      
      let yoyCashFlows = this.dataService.getPlanAnalysisyoyCashFlows();
      if(yoyCashFlows!== null){
        if(yoyCashFlows.Error){
          this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "CashFlowComponent-populateAppData - Error", {ShowMsg: true, MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.analyticErrorMsg});                    
        } else {
          this.dataSource =  yoyCashFlows;
          this.isDataAvailable = true;
          this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "CashFlowComponent-populateAppData", false);
        }
      }
    }
  }

  ngOnDestroy(): void{
    // if(this._storeAppContextSubscription && this._storeAppContextSubscription !== null){
    //   this._storeAppContextSubscription.unsubscribe();
    // }
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }    
    // if(this._uiStateSubscription && this._uiStateSubscription !== null){
    //   this._uiStateSubscription.unsubscribe();    
    // }
 }

}
